export const IS_SMALL_SIZE = window.matchMedia("(max-width: 425px)").matches;
export const IS_MOBILE_SIZE = window.matchMedia("(max-width: 320px)").matches;
export const IS_MOBILE = window.matchMedia("(max-width: 735px)").matches;
export const IS_TABLET = window.matchMedia("(max-width: 1103px)").matches;
export const IS_PC = window.matchMedia("(max-width: 1440px)").matches;
export const IS_LARGE_PC = window.matchMedia("(max-width: 2560px)").matches;

export const parallaxScaleSize = 1.2;